(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KEY = 'ss_nl_state';
    const DAYS = 30;
    const read = () => {
      try {
        return JSON.parse(localStorage.getItem(KEY) || 'null');
      } catch (e) {
        return null;
      }
    };
    const save = (value) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(value));
      } catch (e) {}
    };
    const open = (dialog) => {
      if (dialog.open) return;
      try {
        dialog.showModal();
      } catch (e) {
        dialog.setAttribute('open', '');
      }
    };

    const init = () => {
      const dialog = document.querySelector('[data-ss-nl]');
      if (!dialog || dialog.dataset.ready) return;
      dialog.dataset.ready = '1';

      dialog.querySelector('[data-ss-nl-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        const state = read();
        if (!state || state.s !== 'done') save({ s: 'closed', t: Date.now() });
      });

      const formState = dialog.querySelector('[data-ss-nl-state]')?.dataset.ssNlState;
      if (formState === 'success') {
        save({ s: 'done', t: Date.now() });
        open(dialog);
        return;
      }
      if (formState === 'error') {
        open(dialog);
        return;
      }

      if (window.Shopify && window.Shopify.designMode) return;
      const state = read();
      if (state && (state.s === 'done' || Date.now() - state.t < DAYS * 864e5)) return;
      if (/^\/(cart|checkout|account|challenge|password)/.test(location.pathname)) return;

      const delay = Math.max(2, Number(dialog.dataset.delay) || 8) * 1000;
      setTimeout(() => open(dialog), delay);
    };

    document.addEventListener('shopify:section:select', (event) => {
      const dialog = event.target.querySelector?.('[data-ss-nl]');
      if (dialog) open(dialog);
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      event.target.querySelector?.('[data-ss-nl]')?.close();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-privacy-link"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href$="#cookie-einstellungen"]');
    if (!link) return;
    event.preventDefault();
    const banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') {
      banner.showPreferences();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
